import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../ui/popover";
import { Bell, Inbox } from "lucide-react";
import { useNotifications } from "../../context/NotificationContext";
import NotificationItem from "../Notifikasi/NotificationItem";
import { Link } from "react-router-dom";

export default function NotificationDropdown() {
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();
  const preview = notifications.slice(0, 5);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="relative rounded-full p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-slate-900"
          data-testid="notification-bell"
          aria-label="Notifikasi"
        >
          <Bell className="h-5 w-5" strokeWidth={2} />
          {unreadCount > 0 ? (
            <span
              data-testid="notification-badge"
              className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white ring-2 ring-white"
            >
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          ) : (
            <span
              className="absolute right-1 top-1 h-2 w-2 rounded-full bg-gray-300"
              aria-hidden="true"
            />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-[360px] p-0"
        data-testid="notification-dropdown"
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-3 py-2.5">
          <div>
            <div className="font-display text-[13px] font-bold text-slate-900">
              Notifikasi
            </div>
            <div className="text-[10.5px] text-slate-500">
              {unreadCount} belum dibaca · {notifications.length} total
            </div>
          </div>
          {unreadCount > 0 ? (
            <button
              type="button"
              onClick={markAllAsRead}
              data-testid="notif-mark-all-read"
              className="text-[11px] font-semibold text-[#1e3a5f] hover:underline"
            >
              Tandai semua dibaca
            </button>
          ) : null}
        </div>

        <div className="max-h-[360px] space-y-1.5 overflow-y-auto p-2">
          {preview.length === 0 ? (
            <div
              data-testid="notif-dropdown-empty"
              className="flex flex-col items-center justify-center px-4 py-10 text-center"
            >
              <Inbox className="h-5 w-5 text-slate-400" strokeWidth={1.8} />
              <div className="mt-2 text-[12px] font-semibold text-slate-700">
                Tidak ada notifikasi
              </div>
              <div className="text-[11px] text-slate-500">Semua aman — mantap!</div>
            </div>
          ) : (
            preview.map((n) => (
              <NotificationItem
                key={n.id}
                notif={n}
                onMarkRead={markAsRead}
                compact
              />
            ))
          )}
        </div>

        <div className="border-t border-gray-200 p-2">
          <Link
            to="/notifikasi"
            data-testid="notif-view-all"
            className="block rounded-md bg-[#1e3a5f] py-2 text-center text-[12px] font-semibold text-white hover:bg-[#152a46]"
          >
            Lihat semua notifikasi
          </Link>
        </div>
      </PopoverContent>
    </Popover>
  );
}
